<div *ngIf="checkViewMode('edit') || checkViewMode('view')" class="col-md-12">
  <img [src]="attribute.value"
       [attr.width]="imageWidth"
       [attr.height]="imageHeight"
       [style.max-width.%]="70"
       [alt]="getTitle()" />
</div> 